import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch } from 'react-router'

import settings from '../config/settings'
import PrivateRoute from './components/PrivateRoute'
import Route from './components/Route'
import CompleteEmailLogin from './CompleteEmailLogin'
import CompleteFacebookRedirectLogin from './CompleteFacebookRedirectLogin'
import CompleteInstagramRedirectLogin from './CompleteInstagramRedirectLogin'
import Home from './Home'
import ImageDownload from './ImageDownload'
import Item from './Item'
import ItemEdit from './ItemEdit'
import Notifications from './Notifications'
import Kit from './Kit'
import KitEdit from './KitEdit'
import KitEditSearch from './KitEditSearch'
import PostKit from './PostKit'
import Post from './Post'
import PostComments from './PostComments'
import PostEdit from './PostEdit'
import PostTag from './PostTag'
import PostShare from './PostShare'
import NotFound from './NotFound'
import Onboard from './Onboard'
import EditWaist from './EditWaist'
import EditWeight from './EditWeight'
import EditChest from './EditChest'
import EditHeight from './EditHeight'
import EditStatistics from './EditStatistics'
import EditShape from './EditShape'
import EditInfo from './EditInfo'
import ActivateUser from './ActivateUser'
import AddVerification from './AddVerification'
import Report from './Report'
import Search from './Search'
import Login from './Login'
import Verify from './Verify'
import LoginEmail from './LoginEmail'
import LoginEmailSent from './LoginEmailSent'
import User from './User'
import NotActivatedUser from './notActivated/User'
import HackMe from './HackMe' // FOR TESTING ONLY
import QuickLogin from './QuickLogin'

// Note: the key is needed for each route here ref: https://stackoverflow.com/a/31816415/6637365
class Routes extends Component {
	render() {
		const key = this.props.keyPostfix
		return (
			<Switch>
				<PrivateRoute
					key="home"
					exact
					path="/"
					component={Home}
				/>
				<Route
					key="loginEmailSent"
					exact
					path="/login/email/sent"
					component={LoginEmailSent}
				/>
				<Route
					key="loginEmail"
					exact
					path="/login/email"
					component={LoginEmail}
				/>
				<Route
					key="login"
					exact
					path="/login/instagram"
					component={QuickLogin}
					componentProps={{ provider: 'instagram' }}
				/>
				<Route
					key="login"
					exact
					path="/login/facebook"
					component={QuickLogin}
					componentProps={{ provider: 'facebook' }}
				/>
				<Route
					key="login"
					exact
					path="/login"
					component={Login}
				/>
				<Route
					key="verify"
					exact
					path="/verify/:username"
					component={Verify}
				/>
				<PrivateRoute
					key="uuser"
					exact
					path="/u/:userName"
					component={User}
				/>
				<PrivateRoute
					key="uuser"
					exact
					path="/u"
					component={User}
				/>
				<PrivateRoute
					key="user"
					exact
					path="/user/:userName"
					component={User}
				/>
				<PrivateRoute
					key="user"
					exact
					path="/user"
					component={User}
				/>
				<PrivateRoute
					key="userprofile"
					exact
					path="/userprofile/:userName"
					component={NotActivatedUser}
					allowNotActivated
				/>
				<PrivateRoute
					key="userprofile"
					exact
					path="/userprofile"
					component={NotActivatedUser}
					allowNotActivated
				/>
				<Route
					key={`completeES${key}`}
					exact
					path="/completeEmailLogin"
					component={CompleteEmailLogin}
				/>
				<Route
					key={`completeFBR${key}`}
					exact
					path="/completeFacebookRedirectLogin"
					component={CompleteFacebookRedirectLogin}
				/>
				<Route
					key={`completeIGR${key}`}
					exact
					path="/completeInstagramRedirectLogin"
					component={CompleteInstagramRedirectLogin}
				/>
				<PrivateRoute
					key="search"
					exact
					path="/search"
					component={Search}
				/>
				<PrivateRoute
					key="report"
					exact
					path="/report"
					component={Report}
					allowNotActivated
				/>
				<PrivateRoute
					key="feedback"
					exact
					path="/feedback"
					component={Report}
					allowNotActivated
				/>
				<PrivateRoute
					key="itemEdit"
					exact
					path="/item/edit"
					component={ItemEdit}
				/>
				<PrivateRoute
					key="item"
					exact
					path="/item/:itemKey"
					component={Item}
				/>
				<PrivateRoute
					key="item"
					exact
					path="/item/:itemName/:itemKey"
					component={Item}
				/>
				<PrivateRoute
					exact
					key="/notifications"
					path="/notifications"
					component={Notifications}
				/>
				<PrivateRoute
					key={`kiteditsearch${key}`}
					exact
					path="/kit/edit/search/:kitId"
					component={KitEditSearch}
				/>
				<PrivateRoute
					key={`kiteditsearch${key}`}
					exact
					path="/kit/edit/search"
					component={KitEditSearch}
				/>
				<PrivateRoute
					key={`kitsuggest${key}`}
					exact
					path="/kit/suggest/:kitId"
					component={KitEditSearch}
					componentProps={{ isSuggestion: true }}
				/>
				{/* this route is not really used, but we do want to handle the bad route '/suggest' without kit key in the right component */}
				<PrivateRoute
					key={`kitsuggest${key}`}
					exact
					path="/kit/suggest/"
					component={KitEditSearch}
					componentProps={{ isSuggestion: true }}
				/>
				<PrivateRoute
					exact
					key="/kit/edit/"
					path="/kit/edit/"
					component={KitEdit}
				/>
				<PrivateRoute
					exact
					key="/kit/edit/:kitId"
					path="/kit/edit/:kitId"
					component={KitEdit}
				/>
				<PrivateRoute
					exact
					key="/post/tag/:postId"
					path="/post/tag/:postId"
					component={PostTag}
				/>
				<PrivateRoute
					exact
					key="/post/tag"
					path="/post/tag"
					component={PostTag}
				/>
				<PrivateRoute
					exact
					key="/post/share"
					path="/post/share"
					component={PostShare}
				/>
				<PrivateRoute
					exact
					key="/post/share/:postId"
					path="/post/share/:postId"
					component={PostShare}
				/>
				<PrivateRoute
					exact
					key="/post/edit/:postId"
					path="/post/edit/:postId"
					component={PostEdit}
				/>
				<PrivateRoute
					exact
					key="/post/edit"
					path="/post/edit"
					component={PostEdit}
				/>
				<PrivateRoute
					key={`postkitsearchwithpostid${key}`}
					exact
					path="/postkit/search/:postId"
					component={KitEditSearch}
					componentProps={{ isPostkit: true }}
				/>
				<PrivateRoute
					key={`postkitsearch${key}`}
					exact
					path="/postkit/search"
					component={KitEditSearch}
					componentProps={{ isPostkit: true }}
				/>
				<PrivateRoute
					exact
					path="/postkit/:postId"
					component={PostKit}
				/>
				<PrivateRoute
					exact
					path="/postkit"
					component={PostKit}
				/>
				<PrivateRoute
					exact
					key="/post/comments/:postId"
					path="/post/comments/:postId"
					component={PostComments}
				/>
				<PrivateRoute
					exact
					key="/post/:postId"
					path="/post/:postId"
					component={Post}
				/>
				<PrivateRoute
					key={`kit${key}`}
					exact
					path="/kit/:kitId"
					component={Kit}
				/>
				{/* Note: This needs to be after other /kit/[SOMETHING] paths, so it doesn't match them */}
				<PrivateRoute
					key={`kitcol${key}`}
					exact
					path="/kit/:colour/:kitId"
					component={Kit}
				/>
				<PrivateRoute
					key="onboarding"
					exact
					path="/onboarding"
					component={Onboard}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditWaist"
					exact
					path="/editwaist"
					component={EditWaist}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditWeight"
					exact
					path="/editweight"
					component={EditWeight}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditChest"
					exact
					path="/editchest"
					component={EditChest}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditHeight"
					exact
					path="/editheight"
					component={EditHeight}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditStatistics"
					exact
					path="/editstatistics"
					component={EditStatistics}
					allowNotActivated
				/>
				<PrivateRoute
					key="AddVerification"
					exact
					path="/addverification"
					component={AddVerification}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditShape"
					exact
					path="/editshape"
					component={EditShape}
					allowNotActivated
				/>
				<PrivateRoute
					key="EditInfo"
					exact
					path="/editinfo"
					component={EditInfo}
					allowNotActivated
				/>
				<PrivateRoute
					key="imagedownload"
					exact
					path="/imagedownload"
					component={ImageDownload}
					allowNotActivated
				/>
				<PrivateRoute
					key="ActivateUser"
					exact
					path="/activateuser"
					component={ActivateUser}
				/>
				{/* This is for testing only, MUST BE REMOVED IN PRODUCTION */}
				{settings.options.enableDebug && (
					<Route
						key="hackMe"
						exact
						path="/hackMe"
						component={HackMe}
					/>
				)}
				{/* Not Found route needs to be last */}
				<Route
					key={`notfound${key}`}
					component={NotFound}
				/>
			</Switch>
		)
	}
}

Routes.propTypes = {
	keyPostfix: PropTypes.string
}

Routes.defaultProps = {
	keyPostfix: ''
}

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.jsx